<button mat-button class="m-0 py-1 text-primary-200 h6 text-nowrap" (click)="onExportButtonClicked()" [disabled]="isDisabled">
  <app-icon name="bold-export" size="xs" class="mr-1 text-primary-200"></app-icon>
  {{ "Buttons.Export" | translate }}
</button>
